// extracted by mini-css-extract-plugin
export default {"tile":"BrandTile_tile__CKDLb","logo":"BrandTile_logo__t8ZAb"};